import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/vercel/path0/layouts/account.vue")),
  cart: defineAsyncComponent(() => import("/vercel/path0/layouts/cart.vue")),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue")),
  store: defineAsyncComponent(() => import("/vercel/path0/layouts/store.vue"))
}